import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Cloud, CheckCircle2, XCircle } from "lucide-react";

export default function DrivePanel() {
  const [drive, setDrive] = useState(null);

  useEffect(() => {
    api.get("/drive/google/status").then((r) => setDrive(r.data));
  }, []);

  const connect = async () => {
    const r = await api.post("/drive/google/connect");
    alert(r.data.message);
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <div className="border border-zinc-200 bg-white" data-testid="drive-google">
        <div className="p-6 border-b border-zinc-200 flex items-start justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 border border-zinc-200 flex items-center justify-center">
              <Cloud size={22} strokeWidth={1.5} className="text-zinc-600" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-mono">
                Fournisseur · Drive
              </div>
              <h3 className="mt-1 text-lg font-semibold text-zinc-900">Google Drive</h3>
              <p className="mt-1 text-sm text-zinc-600 max-w-lg">
                Une fois connecté, l'arborescence de vos documents classés sera répliquée en
                lecture seule sur Google Drive.
              </p>
            </div>
          </div>
          <div className="text-right">
            {drive?.connected ? (
              <span className="inline-flex items-center gap-2 text-sm text-[#16A34A] font-mono">
                <CheckCircle2 size={14} /> Connecté
              </span>
            ) : (
              <span className="inline-flex items-center gap-2 text-sm text-zinc-500 font-mono">
                <XCircle size={14} /> Non connecté
              </span>
            )}
          </div>
        </div>
        <div className="p-6 flex items-center justify-between gap-6">
          <div className="text-xs text-zinc-500 font-mono">
            <span className="text-[#FF3B30]">MOCKED</span> — intégration OAuth Google Drive prévue en V2
          </div>
          <button
            data-testid="drive-connect-btn"
            onClick={connect}
            disabled
            className="border border-zinc-300 text-zinc-500 px-5 py-2 text-sm opacity-60 cursor-not-allowed"
            title="Non disponible — V2"
          >
            Connecter Google Drive
          </button>
        </div>
      </div>

      <div className="border border-zinc-200 bg-white p-6">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-mono">
          Autres fournisseurs
        </div>
        <div className="mt-3 text-sm text-zinc-600">
          Dropbox, OneDrive et autres : prévus en V2.
        </div>
      </div>
    </div>
  );
}
